<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='7' :sm='8'>
            <a-form-item label='盘号' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择盘号' v-model='queryParam.appSsid'>
                <a-select-option v-for='item in appList' :value='item.appssid' :key='item.appssid'>{{ item.appName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='7' :sm='8'>
            <a-form-item label='第三方' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择第三方' v-model='queryParam.thirdParty'>
                <a-select-option v-for='item in thirdList' :value='item.thirdParty' :key='item.id'>{{ item.thirdName || item.thirdParty }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='7' :sm='8'>
            <a-form-item label='动作' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择动作' v-model='queryParam.action'>
                <a-select-option v-for='item in actionList' :value='item.itemValue' :key='item.itemValue'>{{ item.itemText }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='3' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class='table-operator' style='border-top: 5px'>
        <a-button @click='handleAdd' type='primary' icon='plus'>添加</a-button>
      </div>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowClassName='rowClassName'
        bordered
        @change='handleTableChange'>
        <a-tag slot='allowSkip' slot-scope='text' :color="text === 1 ? 'red' : 'green'">{{ text === 1 ? '是' : '否' }}</a-tag>
        <a-tag slot='remoteSkip' slot-scope='text' :color="text === 1 ? 'red' : 'green'">{{ text === 1 ? '是' : '否' }}</a-tag>
        <a-tag slot='score' slot-scope='text' :color="text > 0 ? 'red' : ''">{{ text }}</a-tag>
        <a-tag slot='status' slot-scope='text' :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '正常' : '冻结' }}</a-tag>
        <span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)'>
            <a-icon type='edit' />
            编辑
          </a>
          <template v-if='!isFallbackRow(record)'>
            <a-divider type='vertical' />
            <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record)'>
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>

      <a-alert type='info' show-icon style='margin-top: 16px'>
        <span slot='message'>字段说明</span>
        <div slot='description'>
          <p>允许跳过：接口收到请求不做任何处理，直接返回一个成功的空对象</p>
          <p>远程跳过：接口收到请求依旧走正常处理逻辑，只是不调用第三方接口，默认接口返回成功，自行构建一个成功的返回对象</p>
          <p>超过次数跳过：接口在10分钟内累计调用第三方失败N次，则默认成功</p>
          <p>分数：人脸检测与人证对比分设置的分值，用来对比接口返回的分值，接口返回的值大于配置的值则为成功</p>
        </div>
      </a-alert>

    </div>
    <third-skip-modal ref='modalForm' @ok='modalFormOk'></third-skip-modal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import moment from 'moment'
import { getThirdSkipList, deleteThirdSkip, getThirdAll } from '@/webpublicapi/third'
import { getDictList } from '@/webpublicapi/dict'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'
import ThirdSkipModal from './modules/ThirdSkipModal'

export default {
  name: 'ThirdPartyConfig',
  components: { ThirdSkipModal },
  data() {
    return {
      dataSource: [],
      loading: false,
      appList: [],
      thirdList: [],
      actionList: [],
      // 查询条件
      queryParam: {
        appSsid: undefined,
        thirdParty: undefined,
        action: undefined
      },
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '盘号',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: '版本号',
          align: 'left',
          dataIndex: 'version'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'channel'
        },
        {
          title: '第三方',
          align: 'left',
          dataIndex: 'thirdParty',
          customRender: (text, record) => record.thirdName || text
        },
        {
          title: '动作',
          align: 'left',
          dataIndex: 'action',
          customRender: (text) => this.actionName(text)
        },
        {
          title: '允许跳过',
          align: 'center',
          dataIndex: 'allowSkip',
          scopedSlots: { customRender: 'allowSkip' }
        },
        {
          title: '远程跳过',
          align: 'center',
          dataIndex: 'remoteSkip',
          scopedSlots: { customRender: 'remoteSkip' }
        },
        {
          title: '超过次数跳过',
          align: 'center',
          dataIndex: 'timesSkip'
        },
        {
          title: '分数',
          align: 'center',
          dataIndex: 'score',
          scopedSlots: { customRender: 'score' }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updatedTime',
          customRender: (text) => this.formatDateTime(text)
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
    this.loadAppList()
    this.loadThirdList()
    this.loadActionList()
  },
  methods: {
    // 更新时间：时间戳(秒/毫秒)转年月日时分秒，日期字符串原样
    formatDateTime(text) {
      if (text === null || text === undefined || text === '') {
        return ''
      }
      const value = String(text)
      if (/^\d+$/.test(value)) {
        const time = value.length <= 10 ? Number(value) * 1000 : Number(value)
        return moment(time).format('YYYY-MM-DD HH:mm:ss')
      }
      return text
    },
    // 盘号为0(全盘号兜底)的配置不允许删除，操作列不展示删除按钮
    isFallbackRow(record) {
      return record.appSsid === '0'
    },
    // 全局兜底行整行底色提示
    rowClassName(record) {
      return this.isFallbackRow(record) ? 'global-fallback-row' : ''
    },
    // 动作 key 映射字典展示名，无匹配回退原值
    actionName(key) {
      const action = this.actionList.find(item => item.itemValue === key)
      return (action && action.itemText) || key
    },
    loadAppList() {
      getApplistExcludingSubApp().then(res => {
        if (res.code === 1000) {
          // 过滤"全部"空值项
          this.appList = (res.data || []).filter(item => item.appssid !== '')
        }
      })
    },
    loadThirdList() {
      getThirdAll().then(res => {
        if (res.code === 1000) {
          this.thirdList = res.data
        }
      })
    },
    loadActionList() {
      getDictList().then(res => {
        if (res.code === 1000 && res.data.third_action) {
          this.actionList = res.data.third_action
        }
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()
      getThirdSkipList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
    },
    handleDelete(record) {
      // 盘号为0的配置不允许删除（按钮已隐藏，此处防御性兜底）
      if (this.isFallbackRow(record)) {
        this.$message.warning('盘号为0的配置不允许删除')
        return
      }
      deleteThirdSkip({ id: record.id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 重置
    searchReset() {
      this.queryParam = {
        appSsid: undefined,
        thirdParty: undefined,
        action: undefined
      }
      this.loadData(1)
    },
    // model回调
    modalFormOk() {
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .global-fallback-row td {
  background: #F0FFF0;
}
</style>
